'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var locale = {
    'zh-cn': {
        placeholder: '请选择时间',
        clear: '清除',
        hour: '时',
        minute: '分',
        second: '秒'
    },
    'zh-tw': {
        placeholder: '請選擇時間',
        clear: '清除',
        hour: '時',
        minute: '分',
        second: '秒'
    },
    'en-us': {
        placeholder: 'Select a Time',
        clear: 'Clear',
        hour: 'H',
        minute: 'M',
        second: 'S'
    }
};

exports['default'] = locale;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/_components/@alicd/next-time-picker/lib/locale/index.js
// module id = 192
// module chunks = 0